import { getAccessToken } from '@/services/cookieDealer'

export async function getOrders(apiUrl: string, userId: string) {
  if (window['SelfServiceBallon'].refreshTokenFunction != null) {
    await window['SelfServiceBallon'].refreshTokenFunction()
  }

  try {
    const VERSION_TRACKING = 2

    const response = await fetch(`${apiUrl}/api/v3/client/${userId}/ordersInTransit?versionTracking=${VERSION_TRACKING}`, {
      method: 'GET',
      headers: { 'X-Authorization': `Bearer ${getAccessToken()}`, 'Content-Type': 'application/json' },
    })
    if (!response.ok) {
      throw new Error('Erro ao buscar dados deste usuário')
    }
    const { result } = await response.json()
    return result
  } catch (error) {
    console.error(error)
    return null
  }
}
